<template>
  <div class="fanshui-page">
    <van-nav-bar
      class="fanshui-nav"
      title="返水中心"
      left-arrow
      @click-left="$router.back()"
    />
    <div class="fanshui-nav-placeholder"></div>

    <div class="fanshui-content">
      <div class="section-title">
        <span class="title-bar"></span>
        <span class="title-text">返水计算</span>
        <van-icon name="info-o" class="title-info" @click="showTips = true" />
      </div>

      <div class="calc-card">
        <div class="calc-row calc-row-range" @click="showPopup = true">
          <span class="calc-label">计算区间</span>
          <div class="calc-range">
            <div>{{ stats.start_time || '-' }}</div>
            <div>{{ stats.end_time || '-' }}</div>
          </div>
          <van-icon name="arrow-down" class="range-arrow" />
        </div>
        <div class="calc-row">
          <span class="calc-label">有效投注</span>
          <span class="calc-value">{{ formatAmount(stats.valid_amount) }}</span>
        </div>
      </div>

      <div class="claim-card">
        <div class="claim-top">
          <div class="claim-info">
            <div class="claim-title">可领返水</div>
            <div class="claim-amount">{{ formatAmount(stats.nojisuan) }}</div>
          </div>
          <div class="claim-action">
            <button
              class="claim-btn"
              :class="{ disabled: !canClaim }"
              :disabled="!canClaim"
              @click="lingqu"
            >
              领取
            </button>
            <div v-if="claimTip" class="claim-tip">{{ claimTip }}</div>
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="showPopup" position="bottom" round>
      <div class="date-popup">
        <div class="date-popup-title">选择统计时间</div>
        <div class="date-list">
          <div
            v-for="item in dateOptions"
            :key="item.value"
            class="date-item"
            :class="{ active: date === item.value }"
            @click="changeDate(item.value)"
          >
            {{ item.label }}
          </div>
        </div>
        <div
          class="date-custom"
          :class="{ active: date === 5 }"
          @click="openCustomCalendar"
        >
          自定义时间
        </div>
      </div>
    </van-popup>

    <van-calendar
      v-model="showCalendar"
      type="range"
      color="#4a8dff"
      :min-date="minDate"
      :max-date="maxDate"
      :default-date="calendarDefaultDate"
      @confirm="onCalendarConfirm"
    />

    <van-dialog
      v-model="showTips"
      title="返水说明"
      confirm-button-text="知道了"
    >
      <div class="tips-content">
        返水根据所选时间区间内的有效投注进行统计。可领返水为当前账户待领取总额，达到最低返水金额后可一键领取。
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'fanshui',
  data() {
    return {
      date: 1,
      showPopup: false,
      showCalendar: false,
      showTips: false,
      customRange: [],
      minDate: new Date(Date.now() - 365 * 24 * 60 * 60 * 1000),
      maxDate: new Date(),
      stats: {
        start_time: '',
        end_time: '',
        valid_amount: 0,
        jisuan: 0,
        nojisuan: 0,
        min_fanshui_money: 0,
      },
      dateOptions: [
        { label: '今日', value: 1 },
        { label: '近7日', value: 2 },
        { label: '近15日', value: 3 },
        { label: '近30日', value: 4 },
      ],
    };
  },
  computed: {
    calendarDefaultDate() {
      if (this.customRange.length === 2) {
        return this.customRange;
      }
      const today = new Date();
      const weekAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
      return [weekAgo, today];
    },
    canClaim() {
      const amount = Number(this.stats.nojisuan || 0);
      const min = Number(this.stats.min_fanshui_money || 0);
      return amount > 0 && amount >= min;
    },
    claimTip() {
      const amount = Number(this.stats.nojisuan || 0);
      const min = Number(this.stats.min_fanshui_money || 0);
      if (amount <= 0) {
        return min > 0 ? `未达最低返水金额${this.formatAmount(min)}` : '';
      }
      if (amount < min) {
        return `未达最低返水金额${this.formatAmount(min)}`;
      }
      return '';
    },
  },
  created() {
    this.getData();
  },
  methods: {
    formatAmount(value) {
      const num = Number(value || 0);
      if (Number.isNaN(num)) {
        return '0';
      }
      return Number.isInteger(num) ? String(num) : num.toFixed(2);
    },
    formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },
    openCustomCalendar() {
      this.showPopup = false;
      this.showCalendar = true;
    },
    onCalendarConfirm(dates) {
      if (!dates || dates.length < 2) {
        return;
      }
      this.customRange = dates;
      this.date = 5;
      this.showCalendar = false;
      this.getData();
    },
    changeDate(val) {
      this.date = val;
      this.showPopup = false;
      this.getData();
    },
    lingqu() {
      if (!this.canClaim) {
        return;
      }
      this.$parent.showLoading();
      this.$apiFun
        .post('/api/dofanshui', {})
        .then(res => {
          this.$parent.hideLoading();
          if (res.code === 200) {
            this.$parent.getUserInfo();
            this.$parent.showTost(1, res.message);
            this.getData();
          } else {
            this.$parent.showTost(0, res.message);
          }
        })
        .catch(() => {
          this.$parent.hideLoading();
        });
    },
    getData() {
      this.$parent.showLoading();
      const params = {
        date: this.date,
        api_type: '',
      };
      if (this.date === 5 && this.customRange.length === 2) {
        params.start_time = this.formatDate(this.customRange[0]);
        params.end_time = this.formatDate(this.customRange[1]);
      }
      this.$apiFun
        .post('/api/getfanshui', params)
        .then(res => {
          if (res.code === 200) {
            this.stats = {
              ...this.stats,
              ...res.data,
            };
          } else {
            this.$parent.showTost(0, res.message);
          }
          this.$parent.hideLoading();
        })
        .catch(() => {
          this.$parent.hideLoading();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.fanshui-page {
  min-height: 100vh;
  background: #f3f6ff;
}

.fanshui-nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #ede9e7;
}

.fanshui-nav-placeholder {
  height: 46px;
}

.fanshui-content {
  padding: 12px;
}

.section-title {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding: 0 4px;
}

.title-bar {
  width: 3px;
  height: 16px;
  background: #4a8dff;
  border-radius: 2px;
  margin-right: 8px;
}

.title-text {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.title-info {
  margin-left: 6px;
  color: #4a8dff;
  font-size: 16px;
}

.calc-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 12px;
}

.calc-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 52px;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f3f8;
  font-size: 14px;
  color: #333;
}

.calc-row:last-child {
  border-bottom: none;
}

.calc-row-range {
  align-items: flex-start;
  cursor: pointer;
}

.calc-label {
  flex-shrink: 0;
  color: #666;
}

.calc-range {
  flex: 1;
  text-align: right;
  font-size: 13px;
  color: #333;
  line-height: 1.6;
  padding: 0 8px;
}

.range-arrow {
  color: #999;
  margin-top: 4px;
}

.calc-value {
  font-weight: 600;
  color: #333;
}

.claim-card {
  background: linear-gradient(135deg, #fff8e8 0%, #fff3d6 100%);
  border-radius: 12px;
  padding: 20px 16px;
  position: relative;
  overflow: hidden;
}

.claim-card::before,
.claim-card::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.35);
}

.claim-card::before {
  width: 120px;
  height: 120px;
  right: -30px;
  top: -30px;
}

.claim-card::after {
  width: 80px;
  height: 80px;
  left: -20px;
  bottom: -20px;
}

.claim-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.claim-info {
  flex: 1;
}

.claim-title {
  font-size: 14px;
  color: #8a6a3a;
  margin-bottom: 8px;
}

.claim-amount {
  font-size: 36px;
  font-weight: 700;
  color: #5c3f1e;
  line-height: 1;
}

.claim-action {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.claim-btn {
  min-width: 88px;
  height: 40px;
  padding: 0 24px;
  border: none;
  border-radius: 20px;
  background: linear-gradient(180deg, #f0c96d 0%, #d9a94a 100%);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.claim-btn.disabled {
  background: #d8d8d8;
  color: #fff;
}

.claim-tip {
  margin-top: 8px;
  padding: 2px 8px;
  background: #fff3cd;
  border-radius: 4px;
  font-size: 11px;
  color: #b8860b;
  white-space: nowrap;
}

.date-popup {
  padding: 16px 12px 24px;
}

.date-popup-title {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}

.date-list {
  display: flex;
  flex-wrap: wrap;
}

.date-item {
  width: 25%;
  padding: 6px;
  box-sizing: border-box;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbced8;
  border-radius: 6px;
  font-size: 14px;
  color: #666;
}

.date-item.active {
  background: #4a8dff;
  border-color: #4a8dff;
  color: #fff;
}

.date-custom {
  margin-top: 12px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbced8;
  border-radius: 6px;
  font-size: 14px;
  color: #666;
}

.date-custom.active {
  background: #4a8dff;
  border-color: #4a8dff;
  color: #fff;
}

.tips-content {
  padding: 8px 16px 4px;
  font-size: 14px;
  line-height: 1.6;
  color: #666;
}
</style>
